<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!--ISO45001 경영검토보고서 기본정보-->
          <c-card title="LBL0010010" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <!--삭제-->
                <c-btn v-if="editable && popupParam.reviewReportId" label="LBLREMOVE" icon="delete_forever" @btnClicked="removeData" />
                <!--저장-->
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!--제목-->
                <c-text
                  required
                  :editable="editable"
                  label="LBLTITLE"
                  name="reportTitle"
                  v-model="data.reportTitle">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <!--작성일-->
                <c-datepicker
                  required
                  :editable="editable"
                  label="LBLREGDATE"
                  name="reportDate"
                  v-model="data.reportDate">
                </c-datepicker>
              </div>
              <div class="col-12">
                <!--보고서 내용-->
                <c-textarea
                  :editable="editable"
                  type="editor"
                  label="LBL0010011"
                  name="reportContents"
                  :editheight="20"
                  v-model="data.reportContents">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="LBL0010012" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!--보고서 첨부파일-->
                <c-upload 
                  :attachInfo="attachInfo"
                  :editable="editable"
                  label="LBL0010012">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'iso-review-report-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        reviewReportId: '',
      }),
    },
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'ISO_REVIEW_REPORT',
        taskKey: '',
      },
      saveUrl: transactionConfig.sai.iso.report.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      regUserName: '',
      updateUrl: '',
      deleteUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      data: {
        reviewReportId: '',
        plantCd: '',
        reportDate: '',
        reportContents: '',
        reportTitle: '',
        regUserId: '',
      },
      updateMode: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.data.reportDate = this.$comm.getToday();
      
      this.detailUrl = selectConfig.sai.iso.report.get.url;
      this.insertUrl = transactionConfig.sai.iso.report.insert.url;
      this.updateUrl = transactionConfig.sai.iso.report.update.url;
      this.deleteUrl = transactionConfig.sai.iso.report.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.reviewReportId) {
        this.$http.url = this.detailUrl;
        this.$http.param = {reviewReportId: this.popupParam.reviewReportId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo',this.data)

          this.$set(this.attachInfo, 'taskKey', this.popupParam.reviewReportId)
        },);
      }
    },
    saveData() {
      if (this.popupParam.reviewReportId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',  // 확인
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',  // 확인
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.reviewReportId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.reviewReportId = result.data.reviewReportId;
      this.$set(this.attachInfo, 'taskKey', this.popupParam.reviewReportId)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.getDetail();
    },
  }
};
</script>
